/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.assetLibraryModule')

  .directive('bulbRotateImage', ['$timeout', 'ASSET_LIBRARY', bulbRotateImage]);

function bulbRotateImage($timeout, ASSET_LIBRARY) {
  return {
    restrict: 'E',
    require: 'ngModel',
    templateUrl: 'ajs/assetlibrary/modal/assetlibrary-rotate-buttons.html',
    link: function link(scope, elem, attrs, ngModelCtrl) {
      let $imageElement; let
        imageAspectRatio;
        /* image component take some time to load, so we need to wait. */
      $timeout(() => {
        $imageElement = $('.thumbnail').find('img');
        imageAspectRatio = ($imageElement.width() / $imageElement.height());
        const $buttonContainer = $('.button-container');
        /*
          * For images that have an unconventional aspect ratio, the image as well as the crop button and rotate
          * button are moved dynamically so the image doesn't overlap with the buttons on rotate.
          */
        if (imageAspectRatio >= ASSET_LIBRARY.ROTATE.IMAGE_ASPECT_RATIO_THRESHOLD) {
          const iteratee = [$imageElement, $buttonContainer];
          iteratee.forEach((container) => {
            container.animate({
              'margin-top': ($imageElement.width() / ASSET_LIBRARY.ROTATE.IMAGE_HEIGHT_RATIO),
            }, 'slow');
          });
        }
      }, 200);

      let rotationDegree = ASSET_LIBRARY.ROTATE.INITIAL_START_DEGREE;
      let counter = 0;

      scope.rotateRight = function () {
        counter++;
        rotationDegree += ASSET_LIBRARY.ROTATE.CONSTANT_ROTATION_DEGREE;
        $imageElement.rotate({
          animateTo: rotationDegree,
        });

        /*
           * Need to perform this check because on the back-end, the library we use for our image
           * modifications doesn't allow for a degree that is greater than 360.
           */
        const result = counter * ASSET_LIBRARY.ROTATE.CONSTANT_ROTATION_DEGREE;
        if (result >= 360) {
          counter = 0;
        }

        // Set the view value
        ngModelCtrl.$setViewValue(result);
      };
    },
  };
}
